import { ApiEndpointTags } from '../imago-mp.types';
import type { Subscription, SubscriptionApiItem } from './subscriptions-query';
import { transformSubscription } from './subscriptions-query';

export type CreateSubscriptionInput = {
    subscriptionName: string;
    customerName: string;
    companyName: string;
    salesforceLink: string;
    comment: string;
    capacityGroupId: string;
    capacityGroupName: string;
    /**
     * Default-tenant store ids. The server does not default these on create,
     * but later workspace provisioning reads them off the subscription, so a
     * subscription created without them is broken. Resolve via
     * `findDefaultStoreIds` from the tenants query.
     */
    imageStoreId: string;
    clientStoreId: string;
};

type CreateSubscriptionResponse = {
    subscription?: SubscriptionApiItem;
};

export const createSubscriptionMutation = {
    query: ({ capacityGroupId, ...fields }: CreateSubscriptionInput) => ({
        url: '/mp/1/subscriptions',
        method: 'post',
        body: {
            subscription: {
                ...fields,
                // capacityGroupId is a Postgres UUID column; '' is invalid
                // UUID syntax and fails the insert, so send null when blank.
                capacityGroupId: capacityGroupId || null,
            },
        },
    }),
    transformResponse: (response: CreateSubscriptionResponse): Subscription => {
        const sub = response?.subscription ?? {};
        return transformSubscription({ ...sub, id: sub.id ?? '' });
    },
    invalidatesTags: [ApiEndpointTags.Subscriptions],
};
